import { render, staticRenderFns } from "./customerformedit.vue?vue&type=template&id=f9fc610a&"
import script from "./customerformedit.vue?vue&type=script&lang=js&"
export * from "./customerformedit.vue?vue&type=script&lang=js&"
import style0 from "./customerformedit.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports